import { render, staticRenderFns } from "./MasterSizeGroupTop.vue?vue&type=template&id=90fdcadc&scoped=true&"
import script from "./MasterSizeGroupTop.vue?vue&type=script&lang=js&"
export * from "./MasterSizeGroupTop.vue?vue&type=script&lang=js&"
import style0 from "./MasterSizeGroupTop.vue?vue&type=style&index=0&id=90fdcadc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fdcadc",
  null
  
)

export default component.exports